import { PropertyInvoiceItemComponent } from './property-invoice-item/property-invoice-item.component';
import { PropertyInvoiceComponent } from './property-invoice.component';
import { CommonModule } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ContentEditableModule } from '@containers/i18n/content-editable/content-editable.module';

@NgModule({
  declarations: [
    PropertyInvoiceComponent,
    PropertyInvoiceItemComponent
  ],
  imports: [
    CommonModule,
    BrowserAnimationsModule,
    TranslateModule,
    ContentEditableModule
  ],
  exports: [
    PropertyInvoiceComponent,
    PropertyInvoiceItemComponent
  ]
})

export class PropertyInvoiceModule { }
